//=====================================================
// 戻るボタン
//=====================================================
import { useHistory } from 'react-router-dom';

interface IFProps {
    onClick? : React.MouseEventHandler<HTMLButtonElement>
}

export function BtnReturn(props: IFProps){

    const history = useHistory();

    return (
        <div className="btn-return-wrapper">
            {typeof props.onClick !== "undefined" ?
                <button className="btn btn-return" onClick={props.onClick}>戻る</button>
            :
                <button className="btn btn-return" onClick={function(){history.goBack()}}>戻る</button>
            }
            
        </div>
        
    );

}